import { request } from '@/shared/api/request'

export const revoke = async (externalId, isEmployee) => {
	return request({ url: `colcontract/ecd/tradeUnion/revoke/${externalId}?isEmployee=${isEmployee}`, method: 'POST' })
}
